/* @ngInject */
const account = (
  accountMetadata,
  accountRequest,
  accountData,
  accountAsk,
  accountFormat
) => {
  const self = {}

  self.metadata = accountMetadata
  self.data = accountData
  self.request = accountRequest
  self.ask = accountAsk
  self.format = accountFormat

  return self
}

export default account



// WEBPACK FOOTER //
// ./public/javascript/sygem/account/services/account.service.js